import {always, has, prop, when} from 'ramda'

import {TOGGLE_MENU} from 'state/actions/types'
import {reduceToggleMenu} from 'state/reducers/reduce/toggleMenu'
import {thunk} from 'utils/fp'

type DefaultState = {
	readonly showMenu: boolean
}

type Action = {
	readonly payload: any
	readonly type: string
}

export type ViewReducer = (state: any, action: Action) => DefaultState

const dispatchTable: Record<string, any> = {
	[TOGGLE_MENU]: reduceToggleMenu,
}

const defaultState = {showMenu: false}

export const viewReducer: ViewReducer = (state = defaultState, action) => {
	const exists = always(has(action.type, dispatchTable))
	const execute = thunk(prop(action.type, dispatchTable))(state, action)

	return when(exists, execute)(state)
}
